import { HttpClient } from '@angular/common/http';
import { AuthService, LanguageSettingsService } from './core/services';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

export let getHostName = (): string => location.hostname;

export class TranslationLoaderFactory {
  static getTranslateLoader(http: HttpClient, authService: AuthService, languageSettingsService: LanguageSettingsService): TranslateLoader {
    if (!authService.isAuthorized()) {
      return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
    }

    if (getHostName() === 'localhost') {
      return new TranslateHttpLoader(http, 'assets/i18n/', '-us.json');
    }

    return {
      getTranslation: (lang: string) => {
        return languageSettingsService.loadTranslation(lang).pipe(
          map(response => response.language_data),
          catchError((error) => {
            console.error(error);
            return of({}); // Return empty translations object
          }),
        );
      }
    } as TranslateLoader;
  }
}

